/** Pre-filled "Hours per Day"; the user can change it per entry. */
export const DEFAULT_HOURS_PER_DAY = 8;

/** Chime only holds hourly rates, so the day rate is always derived from the hours worked. */
export const getLabourDayRate = ({
  ratePerHour,
  hoursPerDay
}: {
  ratePerHour: number;
  hoursPerDay: number;
}) => ratePerHour * hoursPerDay;

export const getLabourAmount = (entry: {
  ratePerHour: number;
  hoursPerDay: number;
  noOfDays: number;
}) => getLabourDayRate(entry) * entry.noOfDays;
